import * as SuggestionsSelector from '../../selectors/Suggestions';
import { setSearch, submitSearch, selectSuggestion } from '../../actions';
import { PANEL_SOURCE } from '../../utils/constants';

export const mapStateToProps = (state, { id }) => {
    const { value, isSelected, icon } = SuggestionsSelector.suggestionById(state, id);
    return { value, isSelected, icon };
};

export const mapDispatchToProps = (dispatch, { id }) => ({
    onClick: (value) => {
        dispatch(selectSuggestion(id));
        dispatch(setSearch(value));
        dispatch(submitSearch({ submitSource: PANEL_SOURCE }));
    },
});
